import { isDefAndNotNull } from '@utils/def';
import { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { ToastContentProps } from 'react-toastify';

import { ICONS_TYPES } from '../../../Icon';

import { ToastProps } from '../../types';

import {
  ArrowDown,
  BodyItem,
  BodyWrapper,
  Label,
  More,
  Root,
  Title,
} from './styles';

const Body: FC<ToastContentProps> = ({ data }) => {
  const { body, title } = data as ToastProps;
  const lines = useMemo(() => (Array.isArray(body) ? body : [body]), [body]);
  const [collapsed, setCollapsed] = useState(true);
  const [showMore, setShowMore] = useState(false);
  const bodyRef = useRef<HTMLDivElement>(null);
  const handleCollapsed = useCallback(() => {
    setCollapsed(false);
    setShowMore(false);
  }, []);

  useEffect(() => {
    if (bodyRef.current) {
      const { clientHeight, scrollHeight } = bodyRef.current;
      if (scrollHeight - clientHeight > 1) {
        setShowMore(true);
      }
    }
  }, [bodyRef]);

  return (
    <Root>
      {isDefAndNotNull(title) && <Title>{title}</Title>}
      <BodyWrapper ref={bodyRef} collapsed={collapsed}>
        {lines.map((line, i) => (
          <BodyItem key={i}>{line}</BodyItem>
        ))}
      </BodyWrapper>
      {showMore && (
        <More onClick={handleCollapsed}>
          <Label>Show more</Label>
          <ArrowDown
            icon={ICONS_TYPES['ChevronDown']}
            onClick={handleCollapsed}
            size={18}
          />
        </More>
      )}
    </Root>
  );
};

export default Body;
